import { useState } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { allTrackers } from "app/services/track/track";

import type { FilterState } from "../utils/filtersReducer";
import { getFooterButtonConfig, getSubtitleFilters, switcherItems } from "../utils/scatterUtils";

import useCompetitorScatterData from "./useCompetitorScatterData";

const useCompetitorScatterWidget = (filters: FilterState) => {
    const { params } = useCurrentStateAndParams();
    const [selectedSwitcherItem, setSelectedSwitcherItem] = useState(0);

    const scatterData = useCompetitorScatterData({ filters });

    const handleSwitcherSelect = (index: number) => {
        setSelectedSwitcherItem(index);
        allTrackers.dispatchTrackEvent("Tab", "click", `Search Competitors/${switcherItems[index].changeFilter}`);
    };

    const switcherConfig =
        switcherItems.length > 1
            ? {
                  items: switcherItems,
                  initialSelectedItem: selectedSwitcherItem,
                  onItemClick: handleSwitcherSelect,
              }
            : undefined;

    const footerButtonsConfig = scatterData.scatterDataItems.length
        ? getFooterButtonConfig({
              ...params,
              risingCompetitors: filters.rising,
              newCompetitors: filters.new,
              selectedPageTab: switcherItems[selectedSwitcherItem].changeFilter,
          })
        : undefined;

    return {
        ...scatterData,
        switcherConfig,
        footerButtonsConfig,
        subtitleFilters: getSubtitleFilters(params.country),
    };
};

export default useCompetitorScatterWidget;
